import { graphql } from "@/gql";

export const CURRENT_USER_QUERY = graphql(`
  query CURRENT_USER_QUERY {
    currentUser {
      id
      fullName
      avatarUrl
      avatarType
      applicationRole
      metadata
      emailAddress
      pendingEmailAddress
      phoneNumber
      pendingPhoneNumber
      userNotifications {
        totalCount
      }
      timezone
      memberships {
        nodes {
          id
          organizationRole
          organizationId
          isGuardmeSupervisor
          isIncidentSupervisor
          isCheckInSupervisor
          groups {
            nodes {
              id
            }
          }
          organization {
            id
            name
            logoUrl
            timezone
            plan {
              id
              name
            }
            defaultMapCenter {
              latitude
              longitude
            }
            defaultMapZoom
          }
        }
      }
    }
  }
`);
